module.exports = __webpack_public_path__ + "static/media/logoArtConcursosLight.97056929.svg";